import { Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CharterDAO } from '../../../../core/services/dao/charterDAO';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../../core/pure-functions/rx-helper';
import { ContainsSubscriptions } from '../../../../core/services/interfaces/contains-subscriptions';
import { getUtcCharterDate } from '../../../../core/models/charter';

@Component({
  selector: 'app-no-captain-modal',
  templateUrl: './cancel-charter-chicken-test.component.html',
  styleUrls: ['./cancel-charter-chicken-test.component.scss'],
})
export class CancelCharterChickenTestComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];

  textBoatOwner: boolean = true;
  textCaptain: boolean = true;
  message: string = '';
  cancellee = 'Boat Owner';

  constructor(
    public dialogRef: MatDialogRef<CancelCharterChickenTestComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private charterDAO: CharterDAO,
  ) {}

  ngOnInit() {
    this.cancellee = this.data.cancellee ?? this.cancellee;
  }

  addSMSPretext() {
    return `Cancellation notification: ${
      this.data.charter.boatName
    } on ${getUtcCharterDate(this.data.charter).format('MM/DD/YYYY')} at ${
      this.data.charter.startTime
    } has been CANCELED for the following reason: ${
      this.message
    }\nCharter number: ${this.data.charter.id}`;
  }

  sendNotificationButtonIsDisabled(): boolean {
    if (
      this.textBoatOwner === false &&
      this.textCaptain === false &&
      this.message.length > 0
    ) {
      return false;
    } else if (
      (this.textBoatOwner === false || this.textCaptain === false) &&
      this.message.length > 0
    ) {
      return false;
    } else if (
      this.textBoatOwner === true &&
      this.textCaptain === true &&
      this.message.length > 0
    ) {
      return false;
    } else {
      return true;
    }
  }

  sendTextToCaptain(): boolean {
    if (
      this.textCaptain &&
      this.data.charter.captainPhoneNumber &&
      this.data.charter.captainPhoneNumber !== this.data.charter.boatOwnerPhone
    ) {
      return true;
    } else if (
      !this.textBoatOwner &&
      this.textCaptain &&
      this.data.charter.boatOwnerPhone &&
      this.data.charter.captainPhoneNumber === this.data.charter.boatOwnerPhone
    ) {
      return true;
    } else {
      return false;
    }
  }

  _continue() {
    if (this.message != null) {
      this.addSMSPretext();

      if (
        this.cancellee === 'Admin' &&
        this.textBoatOwner &&
        this.data.charter.boatOwnerPhone
      ) {
        const SMSTextToBoatOwner = this.charterDAO
          .sendAdminSMS(this.addSMSPretext(), this.data.charter.boatOwnerPhone)
          .subscribe((data) => {});
        this.subs.push(SMSTextToBoatOwner);
      }

      if (this.cancellee === 'Admin' && this.sendTextToCaptain()) {
        const SMSTextToCaptain = this.charterDAO
          .sendAdminSMS(
            this.addSMSPretext(),
            this.data.charter.captainPhoneNumber,
          )
          .subscribe((data) => {});
        this.subs.push(SMSTextToCaptain);
      }
    }

    this.dialogRef.close({
      textBoatOwner: this.textBoatOwner,
      textCaptain: this.textCaptain,
      cancellationReason: this.message,
      cancelled: true,
      message: this.addSMSPretext(),
    });
  }

  cancel() {
    this.dialogRef.close({
      cancelled: false,
    });
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
